<template>
    <div v-for="record in history" :key="record.id" class="mb-6">
        <VacancyHistoryListItem :record />
    </div>
</template>

<script setup lang="ts">
import VacancyHistoryListItem from './VacancyHistoryListItem.vue';
interface Props {
  history: any[]
}

const { history } = defineProps<Props>();
</script>

